export const paymentScheduleEnum = [
    {
        id: 1,
        value: "Active",
    },
    {
        id: 1,
        value: "Processing",
    },
    {
        id: 2,
        value: "Canceled",
    },
    {
        id: 3,
        value: "Completed",
    },
];

export const signatoryStatusEnum = [
    {
        id: 1,
        value: "Enabled",
    },
    {
        id: 2,
        value: "Disabled",
    },
    {
        id: 3,
        value: "Invited",
    },
];

export const monoPaymentTypeEnum = [
    {
        id: 1,
        value: "OneTimeDebit",
    },
    {
        id: 2,
        value: "RecurringDebit",
    },
];

export const approvalStatusEnum = [
    {
        id: 1,
        value: "Pending",
    },
    {
        id: 2,
        value: "Approved",
    },
    {
        id: 3,
        value: "Declined",
    },
    {
        id: 4,
        value: "Failed",
    },
    {
        id: 5,
        value: "Processing",
    },
];

export const genderEnum = [
    {
        id: 0,
        value: "Unspecified",
    },
    {
        id: 1,
        value: "Male",
    },
    {
        id: 2,
        value: "Female",
    },
];

export const inventoryItemEnum = [
    {
        id: 1,
        value: 1,
        name: "Goods",
    },
    {
        id: 2,
        value: 2,
        name: "Services",
    },
];

export const invoiceTypeEnum = [
    {
        id: 0,
        value: "Simple",
    },
    {
        id: 1,
        value: "Professional",
    },
];

export const invoiceStatusEnum = [
    {
        id: 0,
        value: "None",
    },
    {
        id: 1,
        value: "Pending",
    },
    {
        id: 2,
        value: "Paid",
    },
    {
        id: 3,
        value: "Overdue",
    },
    {
        id: 4,
        value: "Draft",
    },
];

export const invoiceMessageTypeEnum = [
    {
        id: 0,
        value: "SendNewInvoice",
    },
    {
        id: 1,
        value: "ResendNewInvoice",
    },
    {
        id: 2,
        value: "SendReminderNewInvoice",
    },
    {
        id: 3,
        value: "SendOverdueNotice",
    },
    {
        id: 4,
        value: "ResendOverdueNotice",
    },
    {
        id: 5,
        value: "NotifyForPaidInvoice",
    },
    {
        id: 6,
        value: "SendReceipt",
    },
];

export const settlementModeEnum = [
    {
        id: 0,
        value: "None",
    },
    {
        id: 1,
        value: "Online",
    },
    {
        id: 2,
        value: "Manual",
    },
];

export const meansOfSettlementEnum = [
    {
        id: 0,
        value: "None",
    },
    {
        id: 1,
        value: "Bank Transfer",
    },
    {
        id: 2,
        value: "Cash",
    },
];
export const TransactionTagEnum = [
    {
        id: 0,
        value: "OutwardTransfer",
    },
    {
        id: 1,
        value: "InwardTransfer",
    },
    {
        id: 2,
        value: "FundwithCard",
    },
    {
        id: 3,
        value: "fee",
    },
    {
        id: 4,
        value: "airtime",
    },
    {
        id: 5,
        value: "Bills",
    },
    {
        id: 6,
        value: "Atm",
    },
    {
        id: 7,
        value: "Pos",
    },
    {
        id: 8,
        value: "Reversal",
    },
    {
        id: 9,
        value: "Savings",
    },
    {
        id: 10,
        value: "CashDeposit",
    },
    {
        id: 11,
        value: "OnlinePayment",
    },
    {
        id: 12,
        value: "undertermined",
    },
    {
        id: 13,
        value: "InterestIncome",
    },
    {
        id: 14,
        value: "CardlessWithdrawal",
    },
    {
        id: 15,
        value: "flexiblesave",
    },
    {
        id: 16,
        value: "fixedsave",
    },
    {
        id: 17,
        value: "paymentLink",
    },
    {
        id: 18,
        value: "PayWithBank",
    },
    {
        id: 19,
        value: "Payoneer",
    },
    {
        id: 20,
        value: "TerminalTransactionSettlement",
    },
    {
        id: 21,
        value: "loan",
    },
    {
        id: 22,
        value: "loanRepayment",
    },
    {
        id: 23,
        value: "loanCharges",
    },
    {
        id: 24,
        value: "PaywithBankSettlement",
    },
    {
        id: 25,
        value: "flexibleSaveInterest",
    },
    {
        id: 26,
        value: "LocalFundsTransfer",
    },
];

export const cardStatusEnum = [
    {
        id: 0,
        value: "None",
    },
    {
        id: 1,
        value: "Order Received",
    },
    {
        id: 2,
        value: "Order Processing",
    },
    {
        id: 3,
        value: "Printing Card",
    },
    {
        id: 4,
        value: "Ready For Delivery",
    },
    {
        id: 5,
        value: "Sent or Ready For Pickup",
    },
    {
        id: 6,
        value: "IsActiveAndInUse",
    },
    {
        id: 7,
        value: "CardHotListed",
    },
    {
        id: 8,
        value: "Deactivated",
    },
    {
        id: 9,
        value: "OrderCancelled",
    },
];

export const cardStatusEnumDelivery = [
    {
        id: 0,
        value: "None",
    },
    {
        id: 1,
        value: "Order Received",
    },
    {
        id: 2,
        value: "Order Processing",
    },
    {
        id: 3,
        value: "Printing Card",
    },
    {
        id: 4,
        value: "Ready For Delivery",
    },
    {
        id: 5,
        value: "Card Sent For Delivery",
    },
    {
        id: 6,
        value: "IsActiveAndInUse",
    },
    {
        id: 7,
        value: "CardHotListed",
    },
    {
        id: 8,
        value: "Deactivated",
    },
    {
        id: 9,
        value: "OrderCancelled",
    },
];

export const cardStatusEnumPickUp = [
    {
        id: 0,
        value: "None",
    },
    {
        id: 1,
        value: "Order Received",
    },
    {
        id: 2,
        value: "Order Processing",
    },
    {
        id: 3,
        value: "Printing Card",
    },
    {
        id: 4,
        value: "Ready For Delivery",
    },
    {
        id: 5,
        value: "Card Ready For Pick up",
    },
    {
        id: 6,
        value: "IsActiveAndInUse",
    },
    {
        id: 7,
        value: "CardHotListed",
    },
    {
        id: 8,
        value: "Deactivated",
    },
    {
        id: 9,
        value: "OrderCancelled",
    },
];

export const cardChannelEnum = [
    {
        id: 0,
        value: "None",
    },
    {
        id: 1,
        value: "ATM",
    },
    {
        id: 2,
        value: "POS",
    },
    {
        id: 3,
        value: "WEB",
    },
];

export const VerificationCheckTypeEnum = [
    {
        id: 1,
        value: "DOCUMENT_VERIFICATION",
    },
    {
        id: 2,
        value: "FACE_MATCH",
    },
    {
        id: 3,
        value: "LIVENESS_CHECK",
    },
];

export const UserTypeEnum = [
    {
        id: 1,
        value: "RETAIL",
    },
    {
        id: 2,
        value: "BUSINESS",
    },
];

export const KYCVerificationStatusEnum = [
    {
        id: 0,
        value: "Created",
    },
    {
        id: 1,
        value: "Pending",
    },
    {
        id: 2,
        value: "Verified",
    },
    {
        id: 3,
        value: "Rejected",
    },
];

export const businessCategoryEnum = [
    {
        id: 1,
        value: "BusinessName",
    },
    {
        id: 2,
        value: "LimitedLiability",
    },
    {
        id: 3,
        value: "Freelancer",
    },
];

export const KYBStatus = [
    {
        id: 0,
        value: "NotDone",
    },
    {
        id: 1,
        value: "NotDone",
    },
    {
        id: 2,
        value: "Pending",
    },
    {
        id: 3,
        value: "InReview",
    },
    {
        id: 4,
        value: "Approved",
    },
    {
        id: 5,
        value: "Rejected",
    },
];

export const BVNStatusEnum = [
    {
        id: 0,
        value: "NotDone",
    },
    {
        id: 1,
        value: "NotDone",
    },
    {
        id: 2,
        value: "Pending",
    },
    {
        id: 3,
        value: "Done",
    },
    {
        id: 4,
        value: "Rejected",
    },
];

export const smeProfileStatusEnum = [
    {
        id: 1,
        value: "PendingActivation",
    },
    {
        id: 2,
        value: "Active",
    },
    {
        id: 3,
        value: "Inactive",
    },
    {
        id: 4,
        value: "Declined",
    },
    {
        id: 5,
        value: "UpdateNeeded",
    },
    {
        id: 6,
        value: "LoggedForApproval",
    },
];

export const legalSearchEnum = [
    {
        id: 0,
        value: "Notpaid",
    },
    {
        id: 1,
        value: "Paid",
    },
    {
        id: 2,
        value: "Waived",
    },
    {
        id: 3,
        value: "BusinessRegistration",
    },
];

export const bentoPayrollStatusEnum = {
    pending: "Pending payroll activation",
    active: "Active consent",
    paused: "Paused",
    disabled: "Disabled",
    noConsent: "No consent found",
};

export const groupTypeEnum = [
    {
        id: 1,
        value: "Organisation", // Organisation means business is a Full Business
    },
    {
        id: 2,
        value: "Group", // Group means business is a Freelancer
    },
];

export const loginCustomerCategory = [
    {
        id: 1,
        value: "ExistingRetailCustomer",
    },
    {
        id: 2,
        value: "NewToBankCustomer",
    },
];

export const kudaBusinessTierEnum = [
    {
        id: 1,
        value: "FreshlyOnboarded",
    },
    {
        id: 2,
        value: "InvitedAdminNewToBank",
    },
    {
        id: 3,
        value: "CompletelyOnboarded",
    },
];

export const pepCompletedStatusEnum = [
    {
        id: 0,
        value: "NotDone",
    },
    {
        id: 1,
        value: "Completed",
    },
];

export const pepCategoryEnum = [
    {
        id: 0,
        value: "None",
    },
    {
        id: 1,
        value: "CloseAssociate",
    },
    {
        id: 2,
        value: "DomesticPEP",
    },
    {
        id: 3,
        value: "FamilyMember",
    },
    {
        id: 4,
        value: "ForeignPEP",
    },
    {
        id: 5,
        value: "InternationalOrganisation",
    },
    {
        id: 6,
        value: "InternationalOrganisationPEP",
    },
    {
        id: 7,
        value: "ProminentPublicFunctions",
    },
];

export const IDTypeEnum = [
    {
        id: 0,
        value: "None",
    },
    {
        id: 1,
        value: "Drivers_License",
    },
    {
        id: 2,
        value: "National_Identity_Card",
    },
    {
        id: 3,
        value: "International_Passport",
    },
    {
        id: 4,
        value: "Others",
    },
    {
        id: 5,
        value: "Voters_Card",
    },
];

export const SMEFileUploadType = [
    {
        id: 1,
        value: "BusinessLogo",
    },
    {
        id: 2,
        value: "CertificateOfIncorperation",
    },
    {
        id: 3,
        value: "MemorandumAndArticlesOfAssociation",
    },
    {
        id: 4,
        value: "ParticularsOfDirectors",
    },
    {
        id: 5,
        value: "ParticularsOfShareHolders",
    },
    {
        id: 6,
        value: "BoardResolution",
    },
    {
        id: 7,
        value: "CACRegistrationForm",
    },
    {
        id: 8,
        value: "UtilityBill",
    },
    {
        id: 9,
        value: "BusinessCertificate",
    },
    {
        id: 10,
        value: "SingleDocument",
    },
    {
        id: 11,
        value: "ScumlBusinessDocument",
    },
    {
        id: 12,
        value: "BankStatement",
    },
    {
        id: 13,
        value: "TenancyAgreement",
    },
    {
        id: 14,
        value: "TinCertificate",
    },
];

//POS ENUMS
export const hardwarePosDeliveryStatus = [
    {
        id: 1,
        value: "Pending",
    },
    {
        id: 2,
        value: "OutForDelivery",
    },
    {
        id: 3,
        value: "Delivered",
    },
];

// CardScheme
export const cardSchemeEnum = [
    {
        id: 1,
        value: "VISA",
    },
    {
        id: 2,
        value: "AFRIGO",
    },
    {
        id: 3,
        value: "VERVE",
    },
];

export const hardwarePosDeliveryType = [
    {
        id: 1,
        value: "Pickup",
    },
    {
        id: 2,
        value: "Delivery",
    },
];
export const hardwarePosType = [
    {
        id: 1,
        value: "Android",
    },
    {
        id: 2,
        value: "Linux",
    },
    {
        id: 3,
        value: "Hybrid",
    },
];
export const hardwareTerminalStatus = [
    {
        id: 1,
        value: "Created",
    },
    {
        id: 2,
        value: "AccessTokenCreated",
    },
    {
        id: 3,
        value: "SubAccountCreated",
    },
    {
        id: 4,
        value: "TerminalOnboarded",
    },
    {
        id: 5,
        value: "Active",
    },
    {
        id: 6,
        value: "Deactivated",
    },
];

//
export const posType = [
    {
        id: 0,
        value: "SoftPos",
    },
    {
        id: 1,
        value: "HardWarePos",
    },
    {
        id: 2,
        value: "Virtual",
    },
];
export const virtualTerminalStatus = [
    {
        id: 1,
        value: "Active",
    },
    {
        id: 2,
        value: "Deactivated",
    },
    {
        id: 3,
        value: "Closed",
    },
];

export const PosPaymentChannel = [
    {
        id: 1,
        value: "Card",
    },
    {
        id: 2,
        value: "Transfer_Interbank",
    },
    {
        id: 3,
        value: "TransferReversal_Interbank",
    },
    {
        id: 4,
        value: "Transfer_Local",
    },
    {
        id: 5,
        value: "TransferReversal_Local",
    },
    {
        id: 6,
        value: "PayWithKuda",
    },
    {
        id: 7,
        value: "PayWithUSSD",
    },
];

export const paymentType = [
    {
        id: 0,
        value: "OneTime",
    },
    {
        id: 1,
        value: "Instalment",
    },
];
export const paymentScheduleType = [
    {
        id: 1,
        value: "ThreeMonths",
    },
    {
        id: 2,
        value: "SixMonths",
    },
    {
        id: 3,
        value: "NineMonths",
    },
];

export const paymentChannel = [
    {
        id: 0,
        value: "PayWithMainAccount",
    },
    {
        id: 1,
        value: "FundWithBank",
    },
    {
        id: 2,
        value: "PayWithCard",
    },
    {
        id: 3,
        value: "PayWithTransfer",
    },
];

export const disputeTransactionEnum = [
    {
        id: 1,
        value: "Transfers",
        subtransactionType: "OutwardsBankTransferKudaToOtherbanks",
        transactionTypeId: 5,
        method: 0,
        tagName: null,
        categoryId: null,
    },
    {
        id: 2,
        value: "Transfers",
        subtransactionType: "InwardsBankTransferOtherBanksToKuda",
        transactionTypeId: 5,
        method: 1,
        tagName: null,
        categoryId: null,
    },
    {
        id: 3,
        value: "Transfers",
        subtransactionType: "InwardsBankTransferOtherBanksToKuda",
        transactionTypeId: 5,
        method: 1,
        tagName: null,
        categoryId: null,
    },
    {
        id: 4,
        value: "Transfers",
        subtransactionType: "InwardsDebitCardOtherBanksToKuda",
        transactionTypeId: 5,
        method: 2,
        tagName: null,
        categoryId: null,
    },
    {
        id: 5,
        value: "Transfers",
        subtransactionType: "OutwardsPayWithBank",
        transactionTypeId: 5,
        method: 18,
        tagName: null,
        categoryId: null,
    },
    {
        id: 6,
        value: "Transfers",
        subtransactionType: "InwardsCashDepositOtherBanksToKuda",
        transactionTypeId: 5,
        method: 10,
        tagName: null,
        categoryId: null,
    },
    {
        id: 7,
        value: "BillPayments",
        subtransactionType: "Airtime",
        transactionTypeId: 1,
        method: 4,
        tagName: "airtime",
        categoryId: null,
    },
    {
        id: 8,
        value: "BillPayments",
        subtransactionType: "Betting",
        transactionTypeId: 1,
        method: 5,
        tagname: "betting",
        categoryId: null,
    },
    {
        id: 9,
        value: "BillPayments",
        subtransactionType: "Electricity",
        transactionTypeId: 1,
        method: 5,
        tagname: "betting",
        categoryId: null,
    },
    {
        id: 10,
        value: "BillPayments",
        subtransactionType: "GiftCard",
        transactionTypeId: 1,
        method: 29,
        tagname: null,
        categoryId: null,
    },
    {
        id: 11,
        value: "BillPayments",
        subtransactionType: "Internet",
        transactionTypeId: 1,
        method: 5,
        tagname: null,
        categoryId: 9,
    },
    {
        id: 12,
        value: "BillPayments",
        subtransactionType: "TV",
        transactionTypeId: 1,
        method: 5,
        tagName: null,
        categoryId: null,
    },
    {
        id: 13,
        value: "BillPayments",
        subtransactionType: "Education",
        transactionTypeId: 1,
        method: 5,
        tagName: "education",
        categoryId: null,
    },
    {
        id: 14,
        value: "BillPayments",
        subtransactionType: "TransportAndToll",
        transactionTypeId: 1,
        method: 5,
        tagName: null,
        categoryId: 2,
    },
    {
        id: 15,
        value: "Savings",
        subtransactionType: "SavingsDepositFixed",
        transactionTypeId: 3,
        method: 16,
        tagName: null,
        categoryId: null,
    },
    {
        id: 15,
        value: "Savings",
        subtransactionType: "SavingsDepositFlexible",
        transactionTypeId: 3,
        method: 15,
        tagName: null,
        categoryId: null,
    },
    {
        id: 16,
        value: "Savings",
        subtransactionType: "SavingsDepositSpendSave",
        transactionTypeId: 3,
        method: 9,
        tagName: null,
        categoryId: null,
    },
    {
        id: 17,
        value: "Cards",
        subtransactionType: "ATM",
        transactionTypeId: 2,
        method: 6,
        tagName: null,
        categoryId: null,
    },
    {
        id: 18,
        value: "Cards",
        subtransactionType: "POS",
        transactionTypeId: 2,
        method: 7,
        tagName: null,
        categoryId: null,
    },
    {
        id: 19,
        value: "Cards",
        subtransactionType: "WEB",
        transactionTypeId: 2,
        method: 11,
        tagName: null,
        categoryId: null,
    },
    {
        id: 20,
        value: "CardlessPayments",
        subtransactionType: "Cgate",
        transactionTypeId: 2,
        method: 14,
        tagName: null,
        categoryId: null,
    },
    {
        id: 21,
        value: "CardlessPayments",
        subtransactionType: "Paycode",
        transactionTypeId: 2,
        method: 14,
        tagName: null,
        categoryId: null,
    },
];

//restriction type
// 1 Activate
// 2 Deactivate

//Status will be deactivated
export const nomineeInviteStatusEnum = [
    {
        id: 1,
        value: "Pending",
    },
    {
        id: 2,
        value: "Accepted",
    },
    {
        id: 3,
        value: "Cancelled",
    },
    {
        id: 4,
        value: "Expired",
    },
    {
        id: 5,
        value: "Claimed",
    },
];

export const directorConsentStatusEnum = [
    {
        id: 0,
        value: "Pending",
    },
    {
        id: 1,
        value: "Approved",
    },
    {
        id: 2,
        value: "Rejected",
    },
];

export const directorRequiredEnum = [
    {
        id: 0,
        value: "NotDone",
    },
    {
        id: 1,
        value: "IsRequired",
    },
    {
        id: 2,
        value: "IsNotRequired",
    },
];

export const registrationPeriodEnum = [
    {
        id: 1,
        value: "PreTwentySeventeen",
    },
    {
        id: 2,
        value: "TwentySeventeen",
    },
    {
        id: 3,
        value: "PostTwentySeventeen",
    },
];

export const transactionPermissionEnum = [
    {
        id: 1,
        value: "Open",
    },
    {
        id: 2,
        value: "PostNoDebit",
    },
    {
        id: 3,
        value: "PostNoCredit",
    },
    {
        id: 4,
        value: "PostNoDebitAndCredit",
    },
];

export const catalogueChannelEnum = [
    {
        id: 1,
        value: "Retail",
    },
    {
        id: 2,
        value: "Business",
    },
    {
        id: 3,
        value: "API",
    },
];

export const catalogueOrderStatusEnum = [
    {
        id: 1,
        value: "Open",
    },
    {
        id: 2,
        value: "Saved ",
    },
    {
        id: 3,
        value: "Settled",
    },
    {
        id: 4,
        value: "Void",
    },
];

export function getIDFromEnum(string, array) {
    const getObj = array.find((item) => item.value === string);
    return getObj?.id;
}

export function getStringFromEnum(id, array) {
    const getObj = array.find((item) => item.id === id);
    return getObj?.value;
}

export function getIDFromDropdownEnum(string, array) {
    const getObj = array.find((item) => item.name === string);
    return getObj?.id;
}

export const bankStatus = {
    unavailable: "unavailable",
    degraded: "degraded",
    active: "active",
};

export const registrationType = [
    { value: "Business Name", id: 1 },
    { value: "Company", id: 2 },
];
export const NatureOfBusinessCategories = [
    { value: "BusinessNameAndCompany", id: 1 },
    { value: "Company", id: 2 },
    { value: "BusinessName", id: 3 },
];

export const ClassOfShares = [
    {
        value: "OrdinaryShares",
        id: 1,
    },
];

export const businessRegsitrationStatus = [
    { value: "Saved", id: 1 },

    { value: "Submitted", id: 2 },

    { value: "UnderReview", id: 3 },

    { value: "AdditionalInformationRequired", id: 4 },

    { value: "Approved", id: 5 },

    { value: "Completed", id: 6 },
];

export const typeOfBusiness = [
    { value: "SoleProprietorship", name: "Sole Proprietorship", id: 1 },
    { value: "Partnership", name: "Partnership", id: 2 },
];

export const paymentMethod = [
    { name: "PaywithKuda", id: 1 },
    { name: "PayWithTransfer", id: 2 },
    {
        name: "PayWithBalance",
        id: 3,
    },
];
